import { render, staticRenderFns } from "./PurchaseOnboardModal.vue?vue&type=template&id=19e075bb&scoped=true"
import script from "./PurchaseOnboardModal.vue?vue&type=script&lang=js"
export * from "./PurchaseOnboardModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOnboardModal.vue?vue&type=style&index=0&id=19e075bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e075bb",
  null
  
)

export default component.exports